import { supabase } from '../client';

export type ObjectHistoryRow = {
  id: string;
  org_id: string;
  table_name: string;
  entity_type: string;
  record_id: string;
  action: 'insert' | 'update' | 'delete';
  attribute_name: string;
  old_value: string | null;
  new_value: string | null;
  changed_by_org_user_id: string | null;
  created_at: string;
  changed_by?: { display_name: string | null; email: string | null } | null;
};

export type ObjectHistoryListFilters = {
  dateFrom?: string;
  dateTo?: string;
  changedByOrgUserId?: string | null;
  action?: 'insert' | 'update' | 'delete' | null;
};

const ALL_ENTITY_TYPES = [
  'candidates',
  'clients',
  'jobs',
  'applications',
  'requisitions',
  'team',
] as const;

export async function listObjectHistory(
  orgId: string,
  entityType: string,
  page: number,
  pageSize: number,
  filters?: ObjectHistoryListFilters
): Promise<{ rows: ObjectHistoryRow[]; total: number }> {
  const from = Math.max(0, (page - 1) * pageSize);
  const to = from + pageSize - 1;

  let q = supabase
    .from('ggj_b2b_object_history')
    .select(
      `
      id,
      org_id,
      table_name,
      entity_type,
      record_id,
      action,
      attribute_name,
      old_value,
      new_value,
      changed_by_org_user_id,
      created_at,
      changed_by:ggj_b2b_org_users!changed_by_org_user_id(display_name,email)
    `,
      { count: 'exact' },
    )
    .eq('org_id', orgId);

  if (entityType && entityType !== 'all') {
    q = q.eq('entity_type', entityType);
  } else {
    q = q.in('entity_type', [...ALL_ENTITY_TYPES]);
  }

  if (filters?.dateFrom) {
    q = q.gte('created_at', new Date(`${filters.dateFrom}T00:00:00.000Z`).toISOString());
  }
  if (filters?.dateTo) {
    q = q.lte('created_at', new Date(`${filters.dateTo}T23:59:59.999Z`).toISOString());
  }
  if (filters?.changedByOrgUserId) {
    q = q.eq('changed_by_org_user_id', filters.changedByOrgUserId);
  }
  if (filters?.action) {
    q = q.eq('action', filters.action);
  }

  const { data, error, count } = await q.order('created_at', { ascending: false }).range(from, to);

  if (error) throw error;

  const rows = (data ?? []) as unknown as ObjectHistoryRow[];
  return { rows, total: count ?? 0 };
}
